export default function scrollTop () {
  $('#scroll-mark').animate({ scrollTop: 0 }, 200);
}
